var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoItSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "74px",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico_ITsupport") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 75 75 75 75 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_ITsupport",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(-1.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1424,53.77 L52.1424,51.812 L52.1264,51.812 L52.1264,37.713 L58.2114,41.212 L58.2464,49.603 L52.1424,53.77 Z M54.4064,61.118 L31.7654,61.118 L31.7654,58.882 L51.1424,58.882 L52.1424,57.882 L52.1424,56.191 L54.4064,54.646 L54.4064,61.118 Z M37.9294,17.229 L37.0704,17.229 C29.2424,17.229 22.8724,23.599 22.8724,31.427 L22.8724,33.57 L21.1174,31.814 C21.3104,22.444 28.1034,15.429 37.0704,15.429 L37.9294,15.429 C46.8964,15.429 53.6904,22.444 53.8834,31.814 L52.1264,33.571 L52.1264,31.427 C52.1264,23.599 45.7574,17.229 37.9294,17.229 L37.9294,17.229 Z M22.8724,53.781 L16.7534,49.603 L16.7884,41.212 L22.8724,37.713 L22.8724,53.781 Z M60.2484,50.125 L60.2094,40.628 L59.7074,39.766 L52.7564,35.769 L55.5944,32.931 L55.8874,32.224 C55.8874,21.509 48.1664,13.429 37.9294,13.429 L37.0704,13.429 C26.8324,13.429 19.1134,21.509 19.1134,32.224 L19.4064,32.931 L22.2434,35.769 L15.2914,39.766 L14.7894,40.628 L14.7514,50.125 L15.1884,50.955 L23.3094,56.5 L24.8724,55.674 L24.8724,31.427 C24.8724,24.701 30.3444,19.229 37.0704,19.229 L37.9294,19.229 C44.6554,19.229 50.1264,24.701 50.1264,31.427 L50.1264,55.674 L50.1424,55.683 L50.1424,56.882 L30.7654,56.882 L29.7654,57.882 L29.7654,62.118 L30.7654,63.118 L55.4064,63.118 L56.4064,62.118 L56.4064,53.28 L59.8124,50.955 L60.2484,50.125 Z",
    id: "Fill-1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoItSupport);
export default __webpack_public_path__ + "static/media/ico_it_support.77859e303e70343e2d56b2f5847eec2f.svg";
export { ForwardRef as ReactComponent };